import {commitMutation, graphql} from 'react-relay';
import type {Environment, Disposable} from 'relay-runtime';
import {csrfToken, socketClientId} from '../../../forecast-app/ticketing/graphql/forecastRelay';
import type {
	submitTicketAiSummaryFeedbackMutation,
	SubmitTicketAiSummaryFeedbackInput,
} from './__generated__/submitTicketAiSummaryFeedbackMutation.graphql';

// ACC-298: persist the thumbs vote (+ optional note) on the active summary. The
// backend returns the hydrated ticket node, so spreading AiSummaryBlock_ticket
// refreshes the summary block's vote state from one mutation.
const mutation = graphql`
	mutation submitTicketAiSummaryFeedbackMutation($input: SubmitTicketAiSummaryFeedbackInput!) {
		submitTicketAiSummaryFeedback(input: $input) {
			clientMutationId
			ticket {
				id
				...AiSummaryBlock_ticket
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: SubmitTicketAiSummaryFeedbackInput,
	onCompleted?: (r: submitTicketAiSummaryFeedbackMutation['response']) => void,
	onError?: (e: Error) => void
): Disposable {
	return commitMutation<submitTicketAiSummaryFeedbackMutation>(environment, {
		mutation,
		variables: {
			input: {csrfToken: csrfToken(), socketClientId: socketClientId(), ...input},
		},
		onCompleted: onCompleted ? response => onCompleted(response) : undefined,
		onError: onError ? error => onError(error) : undefined,
	});
}

export default {commit, mutationId: 'submitTicketAiSummaryFeedbackMutation'};
